import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchRelatedArticles } from "@/v2/queries";
import { labelFor, type V2Category } from "@/v2/categories";
import { decodeEntities } from "@/v2/textUtils";

interface Props {
  category: V2Category;
  currentId: string;
}

export default function RelatedArticles({ category, currentId }: Props) {
  const { data, isLoading } = useQuery({
    queryKey: ["v2", "related", category, currentId],
    queryFn: () => fetchRelatedArticles(category, currentId, 6),
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading || !data || data.length === 0) return null;

  return (
    <section aria-labelledby="related-heading" className="k2-related">
      <h2 id="related-heading" className="k2-h2">
        Fler i {labelFor(category)}
      </h2>
      <ul className="k2-related-list">
        {data.map((a) => (
          <li key={a.id}>
            <Link
              to={`/${a.category}/${a.slug}`}
              className="k2-related-link"
            >
              {decodeEntities(a.title)}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}